<template>
  <div>
    <v-client-table
      class="fixed_header" ref="tableListe"
      :data="reseauxLc"
      :columns="columns"
      :options="options"
      @filter="tableIsFilter">
      <div slot="selected" slot-scope="props" style="text-align:center">
        <input type="checkbox" id="checkbox" :value="props.row" v-model="props.row.selected"
               @click="ajoutPanier(props.row)">
      </div>
      <div slot="nbFaces" slot-scope="props">
        <div class="is-pulled-right">{{props.row.nbFaces}}</div>
      </div>
      <div slot="depCode" slot-scope="props">
        <div class="is-pulled-right">{{props.row.depCode}}</div>
      </div>
      <div slot="colorPicker" slot-scope="props" style="text-align:center">
        <color-marker
          v-model="props.row.couleur"
          @input="colorsPickerChange(props.row)"/>
      </div>
      <div slot="addPanier" slot-scope="props" style="text-align:center">
        <button class="button is-primary" @click="ajouterAuPanier(props.row)">
          <b-icon icon="cart-plus"></b-icon>
        </button>
      </div>
      <div slot="zoom" slot-scope="props" style="text-align:center">
        <a @click="zoomReseau(props.row)">
          <b-icon icon="google-maps" type="is-primary"></b-icon>
        </a>
      </div>
      <div slot="diaporama" slot-scope="props" style="text-align:center">
        <a @click="ouvrirDiaporama(props.row)">
          <b-icon icon="image-multiple" type="is-primary"></b-icon>
        </a>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import * as types from '@/store/creationOpportunite/venteReseauxLc-mutation-type';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import colorMarker from '@/components/general/colorMarker';
import gestionErreur from '@/services/general/gestionErreur';

const VenteReseauxLc = createNamespacedHelpers('venteReseauxLc');
const Modal = createNamespacedHelpers('modal');

export default {
  name: 'liste',
  components: {
    colorMarker,
  },
  data() {
    return {
      refDropDown: 'refDropDown',
      trad: {
        libelle: '↑↓ Libelle',
        depCode: '↑↓ Dept.',
        ville: '↑↓ Ville',
        nbFaces: '↑↓ Nb Faces',
        format: '↑↓ Format',
        selected: 'Panier',
        addPanier: 'Panier',
        colorPicker: 'Couleur',
        zoom: 'Carto',
        diaporama: 'Diapo',
      },
      checked: [],
    };
  },
  watch: {
    reseauxLc(val) {
      if (val.length) {
        this.$emit('liste', {
          data: val,
          type: 'reseauxLc',
        });
      }
    },
  },
  computed: {
    ...VenteReseauxLc.mapGetters({
      reseauxLc: 'reseauxLcWithFilter',
      markersReseauxLc: 'markersReseauxLc',
      getActiveTabReseau: 'activeTabReseau',
      getZoomMarker: 'zoomMarker',
    }),
    ...Modal.mapGetters({
      getIsComponentDiaporama: 'isComponentDiaporama',
      getFacesDiapoSelect: 'facesSelectDiapo',
    }),
    columns() {
      return ['selected', 'libelle', 'depCode', 'ville', 'nbFaces', 'format', 'zoom', 'diaporama', 'colorPicker'];
    },
    activeTab: {
      get() {
        return this.getActiveTabReseau;
      },
      set(value) {
        this.setActiveTabReseau(value);
      },
    },
    facesReseauSelectDiapo: {
      get() {
        return this.getFacesDiapoSelect;
      },
      set(value) {
        this.setFacesReseauSelect(value);
      },
    },
    isComponentDiaporama: {
      get() {
        return this.getIsComponentDiaporama;
      },
      set(value) {
        this.setIsComponentDiaporama(value);
      },
    },
    zoomMarker: {
      get() {
        return this.getZoomMarker;
      },
      set(value) {
        this.setZoomMarker(value);
      },
    },
    options() {
      return {
        headings: {
          selected: this.trad.selected,
          libelle: this.trad.libelle,
          depCode: this.trad.depCode,
          ville: this.trad.ville,
          nbFaces: this.trad.nbFaces,
          format: this.trad.format,
          addPanier: this.trad.addPanier,
          colorPicker: this.trad.colorPicker,
          diaporama: this.trad.diaporama,
          zoom: this.trad.zoom,
        },
        filterByColumn: true,
        filterable: ['depCode'],
        perPageValues: PER_PAGE_VALUE,
        perPage: 99999,
        texts: TEXTS,
        columnsClasses: {
          format: 'ellipsis colonneBoutonFaceLcListe100px ventesReseauxListeTailleColonneFormat',
          libelle: 'ellipsis colonneBoutonFaceLcListe300px ventesReseauxListeTailleColonneLibelle',
          ville: 'ellipsis ventesReseauxListeTailleColonneVille',
          selected: 'colonneBoutonFaceLcListe has-text-centered',
          depCode: 'colonneBoutonFaceLcListe has-text-centered',
          nbFaces: 'colonneBoutonFaceLcListe has-text-centered',
          zoom: 'colonneBoutonFaceLcListe100px has-text-centered',
          diaporama: 'colonneBoutonFaceLcListe100px has-text-centered',
          colorPicker: 'colonneBoutonFaceLcListe100px has-text-centered',
        },
        customSorting: {
          jourDepartLibelle(ascending) {
            return (a, b) => {
              if (ascending) {
                return a.jourDepart >= b.jourDepart ? 1 : -1;
              }
              return a.jourDepart <= b.jourDepart ? 1 : -1;
            };
          },
        },
      };
    },
  },
  methods: {
    ...VenteReseauxLc.mapMutations({
      setReseauxSelected: types.SET_RESEAUX_SELECTED,
      setReseauxSelectedIndicator: types.SET_RESEAUX_SELECTED_INDICATOR,
      setReseauxWithFilter: types.SET_RESEAUX_WITH_FILTER,
      setActiveTabReseau: types.SET_ACTIVE_TAB_RESEAU,
      setZoomMarker: types.SET_ZOOM_MARKER,
    }),
    ...VenteReseauxLc.mapActions({
      actionsUpdateMarkerReseauLc: 'updateMarkerReseauLc',
      actionsEnvoyerCouleurReseau: 'envoyerCouleurReseau',
      actionsGestionPanier: 'gestionPanier',
      actionsPeutAjouterAuPanier: 'peutAjouterAuPanier',
    }),
    ...Modal.mapMutations({
      setIsComponentDiaporama: typesModal.SET_IS_COMPONENT_DIAPORAMA,
      setFacesReseauSelect: typesModal.SET_FACES_SELECT_DIAPO,
    }),
    ajoutPanier(reseau) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      if (!this.actionsPeutAjouterAuPanier) {
        return;
      }
      this.actionsGestionPanier(reseau.num).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        gestionErreur(`Erreur de l'ajout au panier du reseau LC n°${reseau.num}`, e);
        loadingComponent.close();
        throw (e);
      });
    },
    async colorsPickerChange(reseau) {
      const index = this.reseauxLc.findIndex(el => el.num === reseau.num);
      this.reseauxLc[index].couleur = reseau.couleur;
      this.setReseauxWithFilter(this.reseauxLc);
      await this.actionsEnvoyerCouleurReseau({ reseau: reseau, couleur: reseau.couleur });
    },
    zoomReseau(reseau) {
      const marker = this.markersReseauxLc.find((el) => {
        return reseau.latitude === el.position.lat && reseau.longitude === el.position.lng;
      });
      this.activeTab = 0;
      this.zoomMarker = marker;
    },
    ouvrirDiaporama(reseau) {
      reseau.listeFaces.forEach((el) => {
        el.libelleReseau = reseau.libelle;
      });
      this.facesReseauSelectDiapo = reseau.listeFaces;
      this.isComponentDiaporama = true;
    },
    tableIsFilter() {
      this.$emit('liste', {
        data: this.$refs.tableListe.filteredData,
        type: 'reseauxLc',
      });
    },
  },
  mounted() {
    this.tableIsFilter();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxLc/recherche/liste.vue